/**
 * Admin — đăng ký quán từ website (merchant registration leads)
 */
import api from './api';

const BASE = '/admin/merchant-registration-leads';

export type LeadStatus = 'PENDING' | 'APPROVED';

export interface RegistrationLeadKycDraft {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  password?: string | null;
  address?: string | null;
  restaurantName?: string | null;
  restaurantAddress?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  credits?: number | null;
  provinceName?: string | null;
  wardName?: string | null;
  street?: string | null;
  representative?: {
    fullName?: string;
    email?: string;
    phone?: string;
    idNumber?: string;
    idIssueDate?: string;
    idIssuePlace?: string;
    idFrontImageUrl?: string;
    idBackImageUrl?: string;
  };
  bank?: {
    bankCode?: string;
    bankName?: string;
    accountNumber?: string;
    accountName?: string;
    branch?: string;
  };
  photos?: {
    avatarUrl?: string;
    coverUrl?: string;
  };
  hours?: {
    days?: Array<{
      dayOfWeek: number;
      enabled: boolean;
      startTime: string;
      endTime: string;
    }>;
  };
}

export interface MerchantRegistrationLeadRow {
  id: number;
  store_name: string;
  owner_name: string;
  phone: string;
  business_type: string;
  address: string;
  source: string | null;
  ip_address: string | null;
  created_at: string;
  updated_at?: string;
  status?: LeadStatus;
  approved_at?: string | null;
  created_merchant_user_id?: number | null;
  kyc_draft?: RegistrationLeadKycDraft | null;
  kyc_saved_at?: string | null;
}

export interface MerchantRegistrationLeadsListResponse {
  success: boolean;
  data?: MerchantRegistrationLeadRow[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
  message?: string;
}

export async function fetchMerchantRegistrationLeads(params: {
  page?: number;
  limit?: number;
  status?: LeadStatus;
}): Promise<MerchantRegistrationLeadsListResponse> {
  const res = await api.get<MerchantRegistrationLeadsListResponse>(BASE, {
    params: {
      page: params.page,
      limit: params.limit,
      status: params.status,
    },
  });
  return res.data;
}

export async function fetchRegistrationLeadById(leadId: number): Promise<{
  success: boolean;
  data?: MerchantRegistrationLeadRow;
  message?: string;
}> {
  const res = await api.get<{
    success: boolean;
    data?: MerchantRegistrationLeadRow;
    message?: string;
  }>(`${BASE}/${leadId}`);
  return res.data;
}

export type RegistrationLeadKycPayload = RegistrationLeadKycDraft;

export async function saveRegistrationLeadKyc(
  leadId: number,
  body: RegistrationLeadKycPayload
): Promise<{
  success: boolean;
  data?: MerchantRegistrationLeadRow;
  message?: string;
}> {
  const res = await api.put<{
    success: boolean;
    data?: MerchantRegistrationLeadRow;
    message?: string;
  }>(`${BASE}/${leadId}/kyc`, body);
  return res.data;
}

export interface ApproveRegistrationLeadResponse {
  success: boolean;
  message?: string;
  data?: {
    merchant: Record<string, unknown>;
    credits: number;
    creditWarning?: string;
  };
}

export async function approveRegistrationLead(
  leadId: number,
  body: RegistrationLeadKycPayload
): Promise<ApproveRegistrationLeadResponse> {
  const res = await api.post<ApproveRegistrationLeadResponse>(
    `${BASE}/${leadId}/approve`,
    body
  );
  return res.data;
}
